import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { AuthReducer } from "./reducers/AuthReducer";
import { CustomerReducer } from "./reducers/Customer";
import settings from "./reducers/Settings";
import MessageDialog from "./reducers/Dialog";
//import { reducer as reduxFormReducer } from 'redux-form';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import { createWhitelistFilter } from "redux-persist-transform-filter";
import { TopUpReducer } from "./reducers/TopUpReducer";
import { ExchangeReducer } from "./reducers/ExchangeReducer";
import { AgentReducer } from "./reducers/agentReducer";
import { CardReducer } from "./reducers/cardReducer";
import { TopUpAgentReducer } from "./reducers/TopUpAgentReducer ";
import { CurrencyReducer } from "./reducers/CurrencyReducer";
import { TopUpCardReducer } from "./reducers/TopUpCardReducer";
import { AdminReducer } from "./reducers/adminReducer";
import { walletReducer } from "./reducers/walletReducer";
// --------------------------------------------------------------------------------
const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
  auth: AuthReducer,
  admins: AdminReducer,
  topUp: TopUpReducer,
  topUpCard: TopUpCardReducer,
  agentTopup: TopUpAgentReducer,
  exchange: ExchangeReducer,
  customer: CustomerReducer,
  agent: AgentReducer,
  currency: CurrencyReducer,
  card: CardReducer,
  settings,
  MessageDialog,
  wallet: walletReducer,
});

const persistConfig = {
  timeout: 0,
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
  whitelist: ["auth", "settings"],
  transforms: [
    createWhitelistFilter("auth", ["token", "first_name", "last_name"]),
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
  persistedReducer,
  composeEnhancers(middleware)
);


export const persistor = persistStore(store);
